import { DueTag } from "./DueDate";
import { ageLabel, hoursSince, isOverdue } from "./format";
import { useCompleteTask, useSpaceParam, useTasks, useTrashTask } from "./hooks";

/** `waiting` = delegated and awaiting somebody else (PLAN §3). */
export function WaitingView() {
  const space = useSpaceParam();
  const { data, isLoading, error } = useTasks({ status: ["waiting"], space, limit: 200 });
  const complete = useCompleteTask();
  const trash = useTrashTask();

  return (
    <div className="view">
      {isLoading && <p className="muted">Ładowanie…</p>}
      {error && <p className="error">Nie udało się pobrać listy.</p>}
      {data && data.items.length === 0 && <p className="muted">Na nic nie czekasz.</p>}

      <ul className="rows">
        {data?.items.map((task) => {
          const since = task.delegated_at ?? task.created_at;
          const hours = hoursSince(since) ?? 0;
          return (
            <li key={task.id} className={`row ${isOverdue(task) ? "row--overdue" : ""}`}>
              <label className="row__check">
                <input
                  type="checkbox"
                  checked={false}
                  onChange={() => complete.mutate(task.id)}
                  aria-label={`Doczekane: ${task.title}`}
                />
              </label>
              <div className="row__main">
                <span className="row__title">{task.title}</span>
                <span className="row__meta">
                  <strong>{task.delegated_to ?? "?"}</strong>
                  <span>{ageLabel(since)}</span>
                  {hours >= 24 * 7 && <span className="badge badge--warn">podbić?</span>}
                  <DueTag task={task} />
                </span>
              </div>
              <div className="row__actions">
                <button
                  className="btn btn--small btn--danger"
                  title="Do kosza"
                  onClick={() => trash.mutate(task.id)}
                >
                  🗑
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
